import React from 'react';
import { Users, Lightbulb, Settings, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { services } from '../data/mock';

const Services = () => {
  const iconMap = {
    'users': Users,
    'lightbulb': Lightbulb,
    'settings': Settings
  };

  return (
    <section id="services" className="py-24 bg-slate-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Our Services
            </h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              Comprehensive IT solutions designed to accelerate your business growth and digital transformation
            </p>
            <div className="w-24 h-1 bg-teal-500 mx-auto mt-6"></div>
          </div>

          {/* Services Grid */}
          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const IconComponent = iconMap[service.icon];
              return (
                <Card 
                  key={service.id}
                  className="border-t-4 border-t-teal-500 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 bg-white group"
                >
                  <CardHeader>
                    <div className="w-16 h-16 bg-teal-500/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-teal-500 transition-colors">
                      <IconComponent className="w-8 h-8 text-teal-600 group-hover:text-white transition-colors" />
                    </div>
                    <CardTitle className="text-2xl font-bold text-slate-900 mb-2">
                      {service.title}
                    </CardTitle>
                    <CardDescription className="text-slate-600 text-base leading-relaxed">
                      {service.description}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-3">
                      <p className="text-sm font-semibold text-slate-700 mb-3">Key Features:</p>
                      {service.features.map((feature, idx) => (
                        <div key={idx} className="flex items-center space-x-2">
                          <CheckCircle className="w-5 h-5 text-teal-500 flex-shrink-0" />
                          <span className="text-sm text-slate-700">{feature}</span>
                        </div>
                      ))}
                    </div>
                    <button className="mt-6 w-full py-2 px-4 border-2 border-teal-500 text-teal-600 font-semibold rounded-lg hover:bg-teal-500 hover:text-white transition-colors duration-300">
                      Learn More
                    </button>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          {/* Bottom CTA */}
          <div className="mt-16 text-center">
            <p className="text-lg text-slate-600 mb-6">
              Don't see what you're looking for? We offer custom solutions tailored to your needs.
            </p>
            <button 
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-slate-900 text-white px-8 py-3 rounded-lg font-semibold hover:bg-slate-800 transition-colors"
            >
              Discuss Your Project
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
